import React from "react";
import { useTranslation } from "react-i18next";

const AllWidgets = ({ widget, num, toggleDeviceDetails }) => {
  const { t } = useTranslation();
  const isOn = widget.owner;
  
  return (
    <div
      className={`allwidgets-item ${isOn ? "active" : ""}`}
      onClick={toggleDeviceDetails}
    >
      <div className="allwidgets-icon">
        {widget.property[2] !== "image_path" ? (
          <img src={widget.property[2]} alt="widget" />
        ) : (
          <i className="icon-plug"></i>
        )}
      </div>
      <div className="allwidgets-info">
        <p className="allwidgets-name">{widget.caption?.replace(t("ویجت"), "") || widget.caption}</p>
        <p className={`allwidgets-status ${isOn ? "on" : "off"}`}>
          {isOn ? t("روشن") : t("خاموش")}
        </p>
      </div>
      <div className="allwidgets-num">{num}</div>
    </div>
  );
};

export { AllWidgets };